import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import onClickOutside from 'react-onclickoutside';
import { setMenuState } from '../../../reducers/wizard';

import './navigator.css';

class NavigatorMenu extends React.Component {
    constructor(props) {
        super(props);

        this.close = this.close.bind(this);
        this.escFunction = this.escFunction.bind(this);

        this.onItemClick = this.onItemClick.bind(this);
        this.renderLink = this.renderLink.bind(this);
    }

    componentDidMount() {
        document.addEventListener('keydown', this.escFunction, false);
    }

    handleClickOutside() {
        this.close();
    }

    escFunction(event) {
        if (event.keyCode === 27) {
            this.close();
        }
    }

    close() {
        const { menuActive, setMenuState } = this.props;
        if (menuActive === true) {
            setMenuState(false);
        }
    }

    onItemClick(current) {
        const { navigatorClickable, onStepClick } = this.props;
        if (!navigatorClickable) {
            return;
        }

        onStepClick(current);
        this.close();
    }

    renderLink(step, current, active) {
        if (step.props.hidden) {
            return null;
        }

        const { navigatorClickable, progress } = this.props;
        const navigationOptions = navigatorClickable && current <= progress ? { onClick: () => this.onItemClick(current) } : undefined;

        let classes = 'step-link ';
        if (progress > current) {
            classes += 'complete ';
        } else {
            classes += current <= progress ? 'pending ' : 'disabled ';
        }
        if (current === active) {
            classes += 'active ';
        }

        return (
            <div key={current} className={classes}>
                <span {...navigationOptions} className="no-select">
                    {step.props.title || <FormattedMessage {...step.props.message} />}
                </span>
            </div>
        );
    }

    render() {
        const { menuActive, steps, activeStep } = this.props;

        return (
            <div className={`navigator-menu ${menuActive === true ? 'active' : 'inactive'}`}>
                {steps && steps.map((step, i) => this.renderLink(step, i, activeStep))}
            </div>
        );
    }
}

NavigatorMenu.defaultProps = {
    steps: undefined,
    navigatorClickable: false,
    onStepClick: () => null,
    activeStep: 0,
    progress: undefined
};

NavigatorMenu.propTypes = {
    steps: PropTypes.array,
    navigatorClickable: PropTypes.bool,
    onStepClick: PropTypes.func,
    activeStep: PropTypes.number,
    progress: PropTypes.number
};

const mapStateToProps = state => ({
    menuActive: state.wizard.menuActive
});
const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            setMenuState: setMenuState
        },
        dispatch
    );

NavigatorMenu = onClickOutside(NavigatorMenu);

export default connect(mapStateToProps, mapDispatchToProps)(NavigatorMenu);



// WEBPACK FOOTER //
// ./src/components/wizard/navigator/menu.jsx